export default "__VITE_ASSET__22ee1a5e__"